import React from "react";
import { Navigate } from "react-router-dom";

import Header from "../components/layout/header/Header";
import Footer from "../components/layout/footer/Footer";
import AuditReport, {
  AuditReportDTO,
} from "../components/layout/audit/AuditReport";

import "../App.css";

const ReportPage: React.FC = () => {
  const stored = sessionStorage.getItem("auditReport");

  if (!stored) {
    return <Navigate to="/" replace />;
  }

  const report: AuditReportDTO = JSON.parse(stored);

  return (
    <div className="page-shell page-shell--report">
      <Header />

      <main className="page-shell__content">
        <AuditReport report={report} />
      </main>

      <Footer />
    </div>
  );
};

export default ReportPage;
